export const LINKS = {
    SIGNIN: "/login",

    RESET_PASS: "/sendEmail",
    RESET_EMAIL: "/checkEmailReset/:email",
    CHANGE_PASSWORD: "/ChangePassword",
    CHANGE_PASS_TOKEN: "/changePassword/:token",
    FORGOT_PASS_TOKEN: "/forgotpassword/:token",

    // SETTING: "/setting",
    DESKTOP: "/login_signup",
    PROFILE: "/profile",
    REPORT: "/report",

    TB_LIBRARY: "/tb-library",
    TITLE_TOC: "/titleAndToc",
    CASH_FLOW: "/CashFlow",
    CFS_WORKSHEET: "/cfs-worksheet",
    CFS_GROUPING_LIBRARY: "/cfs-grouping-library",
    CFS_INDIRECT: "/cfs-indirectmethod",
    SFP_STATEMENTS: "/sfp-statements",
    SFP_ACTIVITIES: "/sfp-activities",
    SFP_CASH_FLOW: "/sfp-cash-flow",
    SFP_EXPENSES: "/sfp-expenses",
    SFP_CHECKS: "/sfp-checks",
    SAL_STATEMENTS:"/sal-statements",
    SAL_INVESTMENTS:"/sal-investments",
    SAL_OPERATIONS:"/sal-operations",
    SAL_PARTNER_CAPITAL:"/sal-partner-capital",
    SAL_CASH_FLOW:"/sal-cash-flow",
    SAL_CHECKS: "/sal-checks",
    SAL_WORKPAPER: "/sal-wp",
    CFS_DIRECT: "/cfs-directmethod",
    NOTES: "/notes",
    NOTES_AI: "/notes-ai",
    CHECKS: "/Checks",
    ANALYTICS: "/analytics",

    UNAUTHORIZEERROR: "/unauthorize",

    //V1 routes
    UPLOAD: "/Form",
    GROUP: "/grouping",
    GROUPFS: "/grouping-fs",
    SCHEDULES: "/Schedules",
    TB: "/TrialBalance",
    STOCKHOLDER: "/ES",
    IS: "/IncomeStatement",
    BS: "/BalanceSheet",
    FEEDBACK_FORM: "/feedback-form",
    FEEDBACK_REPORT: "/feedback-report",
    GENERAL_LEDGER:"/generalLedger",


    Layer_Error:"/layer-logs"
}

export const commentsPaths = {
    [LINKS.PROFILE]: "profile-page",
    [LINKS.ADD_CUSTOMER]: "add-customer-page",
    [LINKS.ADD_CUSTOMER_ADMIN]: "add-customer-admin-page",
    [LINKS.ADD_USER]: "add-user-page",
    [LINKS.ADD_CLIENT]: "add-client-page",
    [LINKS.HOME]: "home-page",
    [LINKS.REPORT]: "report-page",
    [LINKS.TB_LIBRARY]: "tb-library-page",
    [LINKS.TITLE_TOC]: "title-toc-page",
    [LINKS.CASH_FLOW]: "cash-flow-page",
    [LINKS.CFS_WORKSHEET]: "cfs-worksheet-page",
    [LINKS.CFS_GROUPING_LIBRARY]: "cfs-grouping-library-page",
    [LINKS.CFS_INDIRECT]: "cfs-indirect-method-page",
    [LINKS.SFP_STATEMENTS]: "sfp-statements",
    [LINKS.SFP_ACTIVITIES]: "sfp-activities",
    [LINKS.SFP_CASH_FLOW]: "sfp-cash-flow",
    [LINKS.SFP_EXPENSES]: "sfp-expenses",
    [LINKS.SFP_CHECKS]: "sfp-checks",
    [LINKS.SAL_STATEMENTS]: "sal-statements",
    [LINKS.SAL_INVESTMENTS]: "sal-investments",
    [LINKS.SAL_OPERATIONS]: "sal-operations",
    [LINKS.SAL_PARTNER_CAPITAL]: "sal-partner-capital",
    [LINKS.SAL_CASH_FLOW]: "sal-cash-flow",
    [LINKS.SAL_CHECKS]: "sal-checks",
    [LINKS.SAL_WORKPAPER]: "sal-workpaper",
    [LINKS.CFS_DIRECT]: "cfs-direct-method-page",
    [LINKS.NOTES]: "notes-page",
    [LINKS.NOTES_AI]: "notes-ai-page",
    [LINKS.CHECKS]: "checks-page",
    [LINKS.ANALYTICS]: "analytics-page",
    [LINKS.SEARCH]: "search-page",
    [LINKS.CAPTION]: "caption-page",
    [LINKS.HELP_SAP]: "help-sap-page",
    [LINKS.SAP]: "sap-page",
    [LINKS.HELP_NOTES]: "help-notes-page",
    [LINKS.COLUMNS]: "columns-page",
    [LINKS.OLD_TB]: "old-trial-balance-page",
    [LINKS.UPLOAD]: "upload-form-page",
    [LINKS.GROUP]: "grouping-page",
    [LINKS.SCHEDULES]: "schedules-page",
    [LINKS.TB]: "trial-balance-page",
    [LINKS.STOCKHOLDER]: "stockholder-equity-page",
    [LINKS.IS]: "income-statement-page",
    [LINKS.BS]: "balance-sheet-page"
    
};